import { useMemo } from 'react';

export function getLockedSectionIdx() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('section')) {
        return null;
    }

    const section = params.get('section');
    if (section === 'null') {
        return null;
    }

    return parseInt(section);
}

export default function useOpenSection() {
  return useMemo(getLockedSectionIdx, []);
}
